"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _Throbber = _interopRequireDefault(require("../Throbber"));
var _excluded = ["src"];
function _callSuper(t, o, e) { return o = (0, _getPrototypeOf2["default"])(o), (0, _possibleConstructorReturn2["default"])(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], (0, _getPrototypeOf2["default"])(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
var PreloadIframe = /*#__PURE__*/function (_React$PureComponent) {
  function PreloadIframe(props) {
    var _this;
    (0, _classCallCheck2["default"])(this, PreloadIframe);
    _this = _callSuper(this, PreloadIframe, [props]);
    _this.state = {
      loaded: false
    };
    _this.elementRef = /*#__PURE__*/_react["default"].createRef();
    _this.loadHandler = _this.loadHandler.bind(_this);
    return _this;
  }
  (0, _inherits2["default"])(PreloadIframe, _React$PureComponent);
  return (0, _createClass2["default"])(PreloadIframe, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mounted = true;
      var current = this.elementRef.current;
      var children = current.getElementsByTagName('iframe');
      var iframe = children[0];
      this.iframe = iframe;
      if (iframe) {
        iframe.addEventListener('load', this.loadHandler);
        iframe.addEventListener('error', this.loadHandler);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.mounted = false;
      if (this.iframe) {
        this.iframe.removeEventListener('load', this.loadHandler);
      }
    }
  }, {
    key: "loadHandler",
    value: function loadHandler() {
      if (this.mounted) {
        this.setState({
          loaded: true
        });
      }
    }
  }, {
    key: "render",
    value: function render() {
      var loaded = this.state.loaded;
      var _this$props = this.props,
        src = _this$props.src,
        props = (0, _objectWithoutProperties2["default"])(_this$props, _excluded);
      var imgStyle = {
        opacity: loaded ? 1 : 0
      };
      return /*#__PURE__*/_react["default"].createElement(StyledContainer, props, !loaded && /*#__PURE__*/_react["default"].createElement(StyledPreloader, null), /*#__PURE__*/_react["default"].createElement("div", {
        ref: this.elementRef,
        dangerouslySetInnerHTML: {
          __html: src
        },
        style: imgStyle
      }));
    }
  }]);
}(_react["default"].PureComponent);
PreloadIframe.propTypes = {
  src: _propTypes["default"].string.isRequired
};
var StyledContainer = _styledComponents["default"].div.withConfig({
  displayName: "PreloadIframe__StyledContainer",
  componentId: "sc-1vu6olj-0"
})(["position:relative;"]);
var StyledPreloader = (0, _styledComponents["default"])(_Throbber["default"]).withConfig({
  displayName: "PreloadIframe__StyledPreloader",
  componentId: "sc-1vu6olj-1"
})(["width:100%;height:100%;margin:0 auto;display:block;position:absolute;"]);
var _default = exports["default"] = PreloadIframe;